module.exports = __webpack_public_path__ + "images/backgrounds/pdf-clouds-adbc58d0e75affcb6b162dec1af694e3.webp";